import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import Select from './filters/Select';
import LocationsSelect from './filters/LocationsSelect';
import Checkboxes from './filters/Checkboxes';
import LargePills from './filters/LargePills';
import { useSettingsContext } from '../contexts/settings';
import Modal from './Modal';

const Filters = () => {
	const { tax, clearFilters, preSelectedTax, clearPreSelectedTax, selectTaxTerm, selectedTax } =
		useFiltersContext();
	const settings = useSettingsContext();
	const taxEntries = Object.entries(tax);

	const [modalOpen, setModalOpen] = React.useState(false);

	const handleClearFilters = () => {
		if (clearFilters) {
			clearFilters();
			setModalOpen(false);
		}
	};

	const handleModalToggle = () => {
		if (clearPreSelectedTax) {
			clearPreSelectedTax();
		}
		setModalOpen(!modalOpen);
	};

	const handleApplyFilters = () => {
		if (preSelectedTax && selectTaxTerm) {
			const entries = Object.entries(preSelectedTax);
			if (entries.length > 0) {
				entries.forEach(([taxName, term]) => {
					selectTaxTerm(taxName, term);
				});
			} else if (clearFilters) {
				clearFilters();
			}
		}
		setModalOpen(false);
	};

	const countSelectedFilters = () => {
		const selectedFilters = Object.entries(selectedTax)
			.filter(([key]) => key !== 'gender')
			.map(([, value]) => value)
			.flat();
		return selectedFilters.length;
	};

	const renderFilters = (postType: string) => {
		switch (postType) {
			case 'before_after':
				const gender = taxEntries.find(([key]) => key === 'gender');
				const procedureType = taxEntries.find(([key]) => key === 'procedure_type');
				const bodyArea = taxEntries.find(([key]) => key === 'body_area');
				const ageRange = taxEntries.find(([key]) => key === 'age_range');
				const skinTone = taxEntries.find(([key]) => key === 'skin_tone');

				return (
					<div className="pfa-filters__tax">
						{gender && <LargePills taxonomy={gender[1]} />}
						<div className="pfa-filters__buttons">
							<button
								className="pfa-filters__reset-filter btn btn-tertiary"
								onClick={handleClearFilters}
							>
								Reset Filters <i className="icon-x-mark" />
							</button>
							<button
								className={`pfa-filters__modal-toggle btn ${
									countSelectedFilters() > 0 &&
									'pfa-filters__modal-toggle--active'
								}`}
								onClick={handleModalToggle}
							>
								Filter the results <i className="icon-filter" />
								{countSelectedFilters() > 0 && (
									<span className="pfa-filters__filter-count">
										{countSelectedFilters()}
									</span>
								)}
							</button>
						</div>
						{modalOpen && (
							<Modal onClose={handleModalToggle} isOpen={modalOpen}>
								<div className="pfa-modal__header" id="modal-header">
									<h2 className="pfa-modal__modal-title">Filter the results.</h2>
								</div>
								<div className="pfa-modal__body" id="modal-body">
									<div className="pfa-modal__row">
										<div className="pfa-modal__col">
											{procedureType && (
												<Checkboxes taxonomy={procedureType[1]} />
											)}
										</div>
										<div className="pfa-modal__col">
											{bodyArea && <Checkboxes taxonomy={bodyArea[1]} />}
										</div>
										<div className="pfa-modal__col">
											{ageRange && <Checkboxes taxonomy={ageRange[1]} />}
											{skinTone && <Checkboxes taxonomy={skinTone[1]} />}
										</div>
									</div>
								</div>
								<div className="pfa-modal__footer">
									<button
										className="pfa-filters__reset-filter btn btn-tertiary"
										onClick={handleClearFilters}
									>
										Reset Filters
									</button>
									<button
										className="pfa-modal__submit btn btn-primary"
										onClick={handleApplyFilters}
									>
										Apply Filters
									</button>
								</div>
							</Modal>
						)}
					</div>
				);
			default:
				return (
					<div className="pfa-filters__tax">
						<div className="pfa-filters__tax-list">
							{settings.filtersToShow.includes('rank_math_locations') && (
								<LocationsSelect />
							)}
							{taxEntries.map(([key, taxonomy]) => (
								<Select taxonomy={taxonomy} key={key} />
							))}
						</div>
					</div>
				);
		}
	};

	if (taxEntries.length || settings.filtersToShow.includes('rank_math_locations')) {
		return (
			<div className={`pfa-filters pfa-filters--${settings.postType}`}>
				{renderFilters(settings.postType)}
			</div>
		);
	}

	return null;
};

Filters.displayName = 'Filters';

export default Filters;
